import { TrainingApprovalRequestStatusEnum } from '../enums/training-approval-request-status.enum';
import { ITrainingApprovalRequestStatus } from '../interfaces/training-approval-request-status.interface';

// @dynamic
export class TrainingApprovalRequestStatus {
    static all: ITrainingApprovalRequestStatus[] = [
        {
            name: TrainingApprovalRequestStatusEnum.DRAFT,
            translationLabel: 'GENERAL.STATUS.DRAFT',
            color: '#000000',
            bgColor: '#D4D4D4',
        },
        {
            name: TrainingApprovalRequestStatusEnum.IN_PROGRESS,
            translationLabel: 'GENERAL.STATUS.IN_PROGRESS',
            color: '#000000',
            bgColor: '#FFE604',
        },
        {
            name: TrainingApprovalRequestStatusEnum.APPROVED,
            translationLabel: 'GENERAL.STATUS.APPROVED',
            color: '#FFFFFF',
            bgColor: '#3774EF',
        },
        {
            name: TrainingApprovalRequestStatusEnum.REJECTED,
            translationLabel: 'GENERAL.STATUS.REJECTED',
            color: '#FFFFFF',
            bgColor: '#F50100',
        },
        {
            name: TrainingApprovalRequestStatusEnum.COMPLETED,
            translationLabel: 'GENERAL.STATUS.COMPLETED',
            color: '#000000',
            bgColor: '#AFD42E',
        },
        {
            name: TrainingApprovalRequestStatusEnum.CANCELED,
            translationLabel: 'GENERAL.STATUS.CANCELED',
            color: '#FFFFFF',
            bgColor: '#F50100',
        },
    ];
}
